import { Component } from 'react'
import { Col, Container, Row } from '@evertel/web/ui'
class Version extends Component {
    render() {
        return (
            <div className="app flex-row align-items-center" style={{height: '100vh', overflow: 'auto'}}>
                <Row align="center" valign="center" className="p-4" style={{ minHeight: '100%', margin: 'auto' }}>
                    <div className="text-center">
                        <h3 className="pt-3 fw-bold">Build info</h3>
                        <h4>Version: {__BUILD__.VERSION}</h4>
                        <h4>Build number: {__BUILD__.NUMBER}</h4>
                        <h4>Commit: {__BUILD__.COMMIT}</h4>
                        <h4>Branch: {__BUILD__.BRANCH}</h4>
                        <h4>Build date: {__BUILD__.DATE}</h4>
                        <h4>Mode: {import.meta.env.MODE}</h4>
                        <h4>Production: {import.meta.env.PROD?'YES':'NO'}</h4>
                    </div>
                </Row>
            </div>
        )
    }
}

export default Version
